import Cookies from 'js-cookie';

export const setCookie = (name: string, value: string, options?: any) => {
    Cookies.set(name, value, { expires: 7, ...options }); // 7일 동안 쿠키 저장
};

export const getCookie = (name: string) => {
    return Cookies.get(name); // 쿠키에서 값 가져오기
};

export const removeCookie = (name: string) => {
    Cookies.remove(name); // 쿠키 삭제
};